import { Field } from 'module/api/field/types';
import {
  BooleanFieldFilter,
  BooleanFilterOperationType,
} from 'module/types/filter-field/filter/boolean';
import { getFieldValue } from 'module/ui/components/molecules/field-filter/filter-functions/get-field-value';
import type { FilterFunction } from 'module/ui/components/molecules/field-filter/types';

export const boolean = (filter: BooleanFieldFilter): FilterFunction => {
  const value = getFieldValue<boolean>(filter.field as any as Field);

  switch (filter.type) {
    case BooleanFilterOperationType.IsEmpty:
    case BooleanFilterOperationType.IsFalse:
      return (record) => value(record) == null || value(record) === false;
    case BooleanFilterOperationType.IsNotEmpty:
    case BooleanFilterOperationType.IsTrue:
      return (record) => value(record) === true;

    default:
      return () => true;
  }
};
